import logo from "./logo1000.png";
import "./App.css";
import AlbumGrid from "./components/AlbumGrid";
import Form from "./components/Form";
import { useState, useEffect } from "react";

const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 200);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="App">
      <div className="content">
        <AlbumGrid />
        <section id="about" className="about-section">
          <h2>ABOUT</h2>
          <p>
            Drums at 9. Bands at 15. Studio at 18. Luke has spent the better
            part of two decades with his hands on music in one form or another,
            drumming, recording, producing, mixing, mastering. What started
            behind a kit turned into a full-blown obsession with sound from
            every angle.
          </p>
          <p>
            Based in Melbourne, he's worked with artists of all stripes. The
            common thread is a stubborn obsession with finding the emotional
            core of a song and making sure nothing gets in the way of it.
          </p>
          <p>
            That curiosity doesn't stop at the mix bus either. These days he
            also builds the software that processes, understands, and reproduces
            sound. Because apparently one obsession wasn't enough.
          </p>
        </section>
        <section id="contact">
          <Form />
        </section>
      </div>

      {showScrollTop && (
        <button className="scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Back to top">
          ↑
        </button>
      )}
      <img src={logo} className="logo" alt="logo" />
      <div className="bottom-bar">
        <div className="bar-identity">
          <span className="bar-name">Luke Mullan</span>
          <span className="bar-tagline">Recording | Mixing | Mastering</span>
        </div>
        <nav className="bottom-nav">
          <button onClick={() => scrollToSection("about")}>About</button>
          <button onClick={() => scrollToSection("contact")}>
            Get In Touch
          </button>
        </nav>
      </div>
    </div>
  );
}

export default App;
